import * as React from 'react';
import cn from 'classnames';

import { SelectorSize } from 'shared/newEntities/components/Selector';
import {
  TypographyWeight,
  TypographySize,
  TypographyType
} from 'shared/newEntities/components/Typography';
import Typography from 'shared/newComponents/Typography';
import { useTypedTranslation } from 'shared/entities/localization';

import './SelectAllItem.modules.scss';

type Props = {
  shouldClear: boolean;
  handler: () => void;
  selectorSize?: SelectorSize;
};

const SelectAllItem: React.FC<Props> = ({
  shouldClear,
  handler,
  selectorSize
}: Props) => {
  const { t } = useTypedTranslation('selectors');

  const handleMouseDown = React.useCallback((event: React.MouseEvent) => {
    event.stopPropagation();
  }, []);

  const isSmall = selectorSize === SelectorSize.small;
  const fontSize = isSmall ? TypographySize.s : TypographySize.m;
  const fontWeight = isSmall
    ? TypographyWeight.normal
    : TypographyWeight.semiBold;
  const itemStyle = cn('select-all-item', isSmall && 'select-all-item_small');

  return (
    <div styleName="select-all-item-container" onMouseDown={handleMouseDown}>
      <div styleName={itemStyle} onClick={handler}>
        <Typography
          fontType={TypographyType.text}
          fontSize={fontSize}
          fontWeight={fontWeight}
          fontColor={null}
        >
          {shouldClear
            ? t('base.content.resetAll')
            : t('base.content.selectAll')}
        </Typography>
      </div>
    </div>
  );
};

export default React.memo(SelectAllItem);
